import { Helmet } from "react-helmet-async";

const SITE = "https://www.btkmortgages.co.uk";
const DEFAULT_IMAGE =
  "https://images.pexels.com/photos/39932417/pexels-photo-39932417.jpeg?auto=compress&cs=tinysrgb&w=1600";
const BRAND = "BTK Mortgage Services";

const Seo = ({ title, description, path = "/", image }) => {
  const url = `${SITE}${path}`;
  const fullTitle = title
    ? `${title} | ${BRAND}`
    : `${BRAND} | Mortgage & Protection Advice in Plain English`;
  const desc =
    description ||
    "A boutique mortgage & protection practice. Berkshire based, serving Berkshire, London, Surrey and the rest of the UK. Whole-of-market advice across 90+ lenders, in plain English.";
  const img = image || DEFAULT_IMAGE;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;
